<template>
	<div class="form">
		<h4 class="step-title">
			<label for="VehicleYear">Vehicle Year</label>
		</h4>
		<div class="step-content d-flex flex-column align-items-center step-button-list">
			<scrollable-button-list
				v-bind:items="years"
				v-bind:onclick="complete"
				v-bind:value="vehicle.year"
			/>
		</div>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";

export default {
	name: "VehicleYear",
	components: {
		ScrollableButtonList,
	},
	props: {
		lead: Object,
	},
	created: function () {
		// initialize vehicles if needed
		if (!this.lead.autoInsurance.vehicles) {
			this.lead.autoInsurance.vehicles = [
				{ year: "", make: "", model: "", trim: "", vin: null },
			];
		}
	},
	computed: {
		vehicle: function () {
			return this.lead.autoInsurance.vehicles[
				this.lead.autoInsurance.vehicles.length - 1
			];
		},
		years: function () {
			var years = [];

                for(var year = this.appConfig.vehicleYearRangeEnd; year >= this.appConfig.vehicleYearRangeStart; year--) {
                    years.push({ text: year, value: year });
                }

			return years;
		},
	},
	methods: {
		complete: function (value) {
			this.vehicle.year = value;
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
